import { Component, ElementRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Settings } from 'src/app/app.settings.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { DialogConfirmacion } from '../dialogs/confirmacion/dialogConfirmacion.component';
import { httpConnect } from 'src/app/services/httpConnect.service';

@Component({
    selector: 'dialog-add-item',
    templateUrl: './catautocompleteAdd.component.html',
    styleUrls : ['./catautocomplete.component.scss'],
    encapsulation: ViewEncapsulation.None
  })
  
  export class DialogCatAC {
    settings: Settings;
    private connectSvc;
    public value: string;
    public title: string = '';
    public label: string = '';
    public padreId: number;
    
    constructor(
      public dialogRef: MatDialogRef<DialogCatAC>,
      private dialog: MatDialog,
    //   private toastaService:ToastaService,
    //   private toastaConfig: ToastaConfig, 
      private httpCon: httpConnect,
      public myStorage: AppOAuthStore,
      @Inject(MAT_DIALOG_DATA) public data: any
      ) {       
        this.connectSvc = httpCon;
        this.title = this.data.type.label;
        this.label = this.data.type.label;
        this.value = this.data.text || '';
        this.padreId = this.data.padreId;
          //this.InicializaFiltroAreas();
        //   this.toastaConfig.theme = "default";
        //   this.toastaConfig.timeout = 7000;
        //   this.toastaConfig.position = "bottom-right";
          //this.fcToasta.toastaItem = { service: this.toastaService, config: this.toastaConfig };
    }
  
    ngOnInit(){
      if(this.value==' ') this.value = '';
    }

    public MostrarDialogConfirmacion(): void {
        let dialogConf = this.dialog.open(DialogConfirmacion, {
          data: { titulo: "Confirmación", mensaje: "¿Desea guardar la información capturada?", tipo: 2, confirm: false },
          // panelClass: "dialog-responsive-cat",
          disableClose: true,
          });
    
          dialogConf.afterClosed().subscribe(result => {
              if (!!result) {
                  if (result.confirm){
                      this.Add();
                  }     
              }      
          });
      }

    public Add() {
        let params = {
            catalogo: this.data.type.tblName,
            value: this.value,
            padreId:this.padreId
          }
          this.connectSvc.postAPI("General", "SetCatalogos_ConsultaXDesc", params)
          .subscribe(result => {
              let res = result.response;
              this.dialogRef.close(res[0]);
           }, err => {
              //this.fcToasta.ShowToasta(err.error.Message, EnumToastaType.Error)
            }
          )
         
    }
  
    onNoClick(): void {
      this.dialogRef.close({});
    }
  }